//
//  Change Password Actions
//  CXA Apollo
//
//  Created on 21/01/2017.
//  Copyright (c) 2017 CXA. All rights reserved.
//
//  payloads of information that send data to our store.
//
import { SubmissionError } from "redux-form";
import api from "../api/flexapi";
import { showToast } from "./toastActions";

// Type of action being performed - Change Password
export const FETCH_PASSWORD_POLICY_SUCCESS = "FETCH_PASSWORD_POLICY_SUCCESS";
export const FETCH_PASSWORD_POLICY_FAILED = "FETCH_PASSWORD_POLICY_FAILED";

export const changePasswordSubmitBegin = "changePasswordSubmitBegin";
export const changePasswordSubmitSuccess = "changePasswordSubmitSuccess";
export const changePasswordSubmitFailed = "changePasswordSubmitFailed";

// Call API to load module data
export function fetchPasswordPolicy(data) {
  // Return thunk middleware
  return dispatch =>
    api
      .passwordPolicy(data)
      .then(response => {
        dispatch({ type: FETCH_PASSWORD_POLICY_SUCCESS, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: FETCH_PASSWORD_POLICY_FAILED,
          payload: err.response ? err.response : err,
        });
        throw new SubmissionError({ _error: err.response.body });
      });
}

export function changePassword(data) {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: changePasswordSubmitBegin, payload: null });

    return api
      .changePassword(data)
      .then(response => {
        dispatch({ type: changePasswordSubmitSuccess, payload: response });

        if (response && response.body && response.body.changeMessage) {
          dispatch(showToast({ message: response.body.changeMessage }));
        }
      })
      .catch(err => {
        if (err.response) {
          dispatch(showToast({ message: err.response.body.messageKey }));
        }
        dispatch({
          type: changePasswordSubmitFailed,
          payload: err.response ? err.response : err,
        });
        throw new SubmissionError({ _error: err.response.body });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/changePasswordActions.jsx